import { CROP_SHAPE_TYPES } from './config';

export const defaultCanvasColor = '#FFFFFF';
export const defaultCanvasColorFrom = '#FFFFFF';
export const defaultCanvasColorTo = '#FFFFFF';
export const defaultBackgroundType = 'solid';
export const defaultBackgroundGradientType = 'vertical';
export const renderer = {
  frameRate: process.env.CAPTURE_FRAMERATE || 25,
  format: 'png'
};
export const canvasSizes = {
  landscape: {
    width: 1920,
    height: 1080
  },
  square: {
    width: 1080,
    height: 1080
  },
  portrait: {
    width: 1080,
    height: 1920
  }
};
export const resolution = 1;
export const defaultScale = 1;

export const EDITOR_CANVAS_CONTROL_VISIBILITY = {
  object: {
    ml: false,
    mr: false,
    mb: false,
    mt: false,
    mtr: true,
    bl: true,
    br: true,
    tl: true,
    tr: true
  },
  objectUnlockedRatio: {
    ml: true,
    mr: true,
    mb: true,
    mt: true,
    mtr: true,
    bl: true,
    br: true,
    tl: true,
    tr: true
  },
  group: {
    ml: false,
    mr: false,
    mb: false,
    mt: false,
    mtr: true,
    bl: true,
    br: true,
    tl: true,
    tr: true
  }
};

const CROP_CANVAS_CONTROL_VISIBILITY_DEFAULTS = {
  mtr: false,
  ml: true,
  mr: true,
  mb: true,
  mt: true,
  bl: true,
  br: true,
  tl: true,
  tr: true
};

export const CROP_CANVAS_CONTROL_VISIBILITY = {
  DEFAULT: {
    ...CROP_CANVAS_CONTROL_VISIBILITY_DEFAULTS
  },
  [CROP_SHAPE_TYPES.SQUARE]: {
    ...CROP_CANVAS_CONTROL_VISIBILITY_DEFAULTS,
    ml: false,
    mr: false,
    mt: false,
    mb: false
  },
  [CROP_SHAPE_TYPES.CIRCLE]: {
    ...CROP_CANVAS_CONTROL_VISIBILITY_DEFAULTS,
    ml: false,
    mr: false,
    mt: false,
    mb: false
  },
  [CROP_SHAPE_TYPES.ELLIPSE]: {
    ...CROP_CANVAS_CONTROL_VISIBILITY_DEFAULTS
  }
};

export const EDITOR_CANVAS_SELECTION_OPTIONS = {
  borderColor: '#17a9ce',
  cornerColor: '#17a9ce',
  selectionBackgroundColor: 'rgba(39, 168, 203, 0.1)',
  transparentCorners: false,
  cornerSize: 16,
  lockScalingFlip: true
};

export const SVG_DEFAULT_STROKE_WIDTH = 1;
export const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
export const MASK_LINE_COLOR = 0xff0000;
export const SCRIBBLE_RESOLUTION = 40;

export const FREE_TIER_PROJECT_LIMIT = 30;
export const SCRIBE_TEXT_LINE_HEIGHT = 1.4;
export const SCRIBE_TEXT_MULT = 1.13;
export const MAX_UPLOADED_IMAGE_DIMENSION = 2048;
export const MAX_CHARS_IN_TEXT = 90;
export const FREE_ELEMENTS_LIMIT = Infinity;
export const WATERMARK_CORNER_PADDING = 40;

export const DEFAULT_TEXT_COLOR = '#131515';

export const ALLOWED_IMAGE_TYPES = ['image/bmp', 'image/svg+xml', 'image/png', 'image/jpeg', 'image/gif'];

const defaults = {
  defaultCanvasColor,
  canvasSizes,
  defaultScale,
  EDITOR_CANVAS_CONTROL_VISIBILITY,
  EDITOR_CANVAS_SELECTION_OPTIONS,
  SVG_DEFAULT_STROKE_WIDTH,
  SVG_NAMESPACE,
  MASK_LINE_COLOR,
  SCRIBBLE_RESOLUTION
};

export default defaults;
